import React, { useState, useEffect } from "react";
import Hero1 from "../../assets/tan.jpg";
import Hero2 from "../../assets/tan1.jpg";
import Hero3 from "../../assets/tan.jpg";
import RightHero1 from "../../assets/Home page (1).png";
import RightHero2 from "../../assets/Home page (2).png";
import RightHero3 from "../../assets/Chyson Food page.png";
import TextFade from "../../components/CustomTexts/TextFade";
import TextEffect from "../../components/CustomTexts/TextEffect";
import { Link } from "react-router-dom";

const Hero = () => {
  const texts = [
    {
      mainText: "Plant Power",
      secondaryText: "Fuel Lives",
      paragraphText:
        "At Simdozi, we're transforming Nigeria's agriculture by prioritizing sustainable farming practices and innovation in crop production.",
    },
    {
      mainText: "Bold Ideas",
      secondaryText: "Real Impact",
      paragraphText:
        "Nothing is beyond reach at Simdozi. We take bold steps to turn your agricultural visions into thriving, sustainable farms.",
    },
    {
      mainText: "Strong Roots",
      secondaryText: " Good Life",
      paragraphText:
        "Simdozi is known for its strong agricultural foundations, using eco-friendly practices to ensure the longevity of our crops and the health of the planet.",
    },
  ];

  const backgroundImages = [Hero2, Hero1, Hero3];
  const rightImages = [RightHero1, RightHero2, RightHero3];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % backgroundImages.length);
        setFade(true);
      }, 500);
    }, 15000);

    return () => clearInterval(interval);
  }, [backgroundImages.length]);

  const { mainText, secondaryText, paragraphText } = texts[index];

  return (
    <div className="relative w-full h-screen max-h-[950px] overflow-hidden">
      {/* Background Image */}
      <div
        className={`absolute inset-0 bg-cover bg-center bg-no-repeat transition-opacity duration-1000 ease-in-out ${
          fade ? "opacity-100" : "opacity-0"
        }`}
        style={{
          backgroundImage: `url('${backgroundImages[index]}')`,
          zIndex: 0,
        }}
      />

      {/* Green Overlay */}
      <div className="absolute inset-0 bg-green-300 bg-opacity-40 z-[1]" />

      {/* Content */}
      <div className="relative z-[2] mt-10 md:mt-10 flex flex-col md:flex-row items-center justify-between h-full w-full px-4 md:px-[5%] pt-24 md:pt-0 text-center md:text-left">
        {/* Text Section */}
        <div className="w-full md:w-[50%] flex flex-col gap-3 md:gap-10 justify-start md:justify-center items-center md:items-start mt-[1.5rem] sm:mt-[1.5rem] md:mt-[4rem]">
          <TextFade animation="fade-up">
            <h1 className="font-bold text-white leading-tight">
              <TextEffect
                part1={mainText}
                responsiveSize="text-[4.5rem] sm:text-[4.5rem] md:text-6xl lg:text-7xl xl:text-8xl"
              />
              <br />
              <TextEffect
                part2={secondaryText}
                responsiveSize="text-[4.5rem] sm:text-[4.5rem] md:text-6xl lg:text-7xl xl:text-8xl"
              />
            </h1>
          </TextFade>

          <p className="text-dark text-sm sm:text-base md:text-lg xl:text-xl md:w-[90%] leading-relaxed">
            {paragraphText}
          </p>

          <div className="flex justify-center md:justify-start w-full mt-4">
            <Link to="/contact">
              <button className="bg-secondary text-white px-5 py-3 rounded-md font-semibold hover:scale-105 hover:shadow-lg transition-all duration-300">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
{/* Right Image Section */}
<div className={`transition-opacity duration-1000 ease-in-out ${fade ? "opacity-100" : "opacity-0"}`}>
  {/* Desktop & Laptop Image */}
  <div className="hidden md:flex absolute bottom-0 right-0 h-full z-[1] items-end justify-end pr-4 w-full md:w-[50%]">
    <img
      src={rightImages[index % rightImages.length]}
      alt="Hero Visual"
      className="object-contain pointer-events-none select-none w-[80%] md:w-[95%] lg:w-[90%] xl:w-[80%] 2xl:w-[90%] max-w-[850px]"
    />
  </div>

  {/* Mobile Image */}
  <div className="block md:hidden absolute bottom-0 right-0 z-[1] flex justify-end pr-4 w-full">
    <img
      src={rightImages[index % rightImages.length]}
      alt="Hero Mobile Visual"
      className="object-contain pointer-events-none select-none w-[90%] max-w-[550px]"
    />
  </div>
</div>

      </div>
    </div>
  );
};

export default Hero;
